import type { SVGProps } from 'react'
const SvgSyFacebook = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={24} height={24} {...props}>
		<path d="M194 297.2V497h109V297.2h81.3l16.9-91.9H303v-32.5c0-48.6 19.1-67.2 68.3-67.2s27.6.4 34.8 1.1V23.5c-13.4-3.7-46.3-7.4-65.3-7.4-100.4 0-146.7 47.4-146.7 149.7v39.5h-62v91.9h62z" />
	</svg>
)
export default SvgSyFacebook
